import styles from './PageDivider.module.less';
import cn from 'classnames';

function PageDivider({ className }: { className?: string }) {
	return <span className={cn(className, styles.divider)} />;
}

export default PageDivider;
